import React from 'react'
import { useFormContext } from 'react-hook-form'

import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import type { EReportType } from '@/store/api/Enterprise/Enterprise.types'
import type { Workspace } from '@/store/api/Workspace/Workspace.types'
import type { creditsSchemaType } from '@/utils/schemas'

interface IWorkspaces {
  title?: string
  creditsAvailable?: number
  workspace: Workspace
  type: EReportType
}

export const ManageCreditsSheetCard = ({
  title,
  creditsAvailable,
  type,
}: IWorkspaces) => {
  const {
    control,
    formState: { isSubmitting },
  } = useFormContext<creditsSchemaType>()

  return (
    <div
      className={` bg-baseColor flex flex-col p-3 justify-between gap-2 rounded-lg w-full `}
    >
      <div className="flex flex-col gap-2">
        <p className="text-neutralColor text-lg">{title}</p>
      </div>
      <div className="flex flex-row gap-4 items-center">
        <div className="w-full">
          <FormField
            control={control}
            name={type}
            render={({ field }) => (
              <FormItem className="">
                <div className="flex flex-col">
                  <FormControl>
                    <Input
                      {...field}
                      type="number"
                      disabled={isSubmitting}
                      onChange={(e) => {
                        const value = parseFloat(e.target.value)
                        field.onChange(value)
                      }}
                      value={field.value.toString()}
                      className="bg-primaryColor5 text-center border-none"
                    />
                  </FormControl>
                </div>

                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      </div>
      <div className="flex flex-row justify-between">
        <p className="text-neutralColor60 text-sm">Available Credits</p>
        <p className="text-neutralColor60 text-sm">Max. {creditsAvailable}</p>
      </div>
    </div>
  )
}
